import { render, staticRenderFns } from "./WorksSection.vue?vue&type=template&id=256069a2&scoped=true&"
import script from "./WorksSection.vue?vue&type=script&lang=js&"
export * from "./WorksSection.vue?vue&type=script&lang=js&"
import style0 from "./WorksSection.vue?vue&type=style&index=0&id=256069a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256069a2",
  null
  
)

export default component.exports